<template>
    <div class="result-group result-group-videos" v-if="results.length > 0">
        <div class="headline">
            {{headline}}
        </div>
        <component v-bind:is="getDownloadType(result)" v-bind:result="result" v-for="result in results"></component>
    </div>
</template>

<script>
    import DownloadResultVideo from "./DownloadResultVideo";
    import DownloadResultFile from "./DownloadResultFile";
    import DocumentResult from "./DocumentResult";

    const resultTemplates = {
        'default': DownloadResultFile,
        'videos': DownloadResultVideo,
        'page': DocumentResult,
    };

    export default {
        name: "DownloadResultGroup",
        props: ['rawResults', 'groupType', 'sorting'],
        data: function () {
            return {
                results: [],
                sortedResults: null
            }
        },
        components: {
            DownloadResultVideo
        },
        computed: {
            headline() {
                return this.$t("service_download.types." + this.groupType);
            }
        },
        watch: {
            rawResults() {
                this.updateResults()
            },
            sorting() {
                this.sortResults();
            }
        },
        methods: {
            sortResults() {
                if (this.sorting === 'asc') {
                    return this.sortAsc();
                }

                if (this.sorting === 'desc') {
                    return this.sortDesc();
                }

                if (this.sorting === 'date_asc') {
                    return this.sortDate('asc');
                }

                if (this.sorting === 'date_desc') {
                    return this.sortDate('desc');
                }

                this.sortAsc();

            },
            updateResults() {
                this.results = [];
                for (var k in this.rawResults) {
                    if (this.rawResults.hasOwnProperty(k)) {
                        var result = this.rawResults[k];
                        result = this.mapResultFields(result);
                        this.results.push(result);
                    }
                }
                this.sortResults();
            },
            mapResultFields(results) {
                let result = {fields: {}, id: null};
                let languageResult = null;

                const language = this.$store.state.language;
                const fallbackLanguage = this.$store.state.fallbackLanguage;
                const skip = ['existing_languages', 'level_0', 'level_1', 'level_2', 'level_3'];

                if (results[language]) {
                    languageResult = results[language];
                }
                if (!languageResult) {
                    languageResult = results[fallbackLanguage];

                    if (!languageResult) {
                        languageResult = results['de'] ? results.de : results[Object.keys(results).pop()];
                    }
                }
                if (languageResult == null) {}

                for (var key in languageResult.fields) {

                    if (languageResult.fields.hasOwnProperty(key)) {
                        let item = languageResult.fields[key];
                        if (item.length > 1 || skip.indexOf(key) !== -1) {
                            result.fields[key] = item;
                        } else {

                            if (isNaN(item[0])) {
                                result.fields[key] = item[0];
                            } else {
                                if (key === '_date_') {
                                    result.fields[key] = new Date(item[0] * 1000)
                                } else {
                                    result.fields[key] = parseInt(item[0]);
                                }

                            }
                        }
                    }
                }
                result.languages = results;
                result.id = languageResult.id;
                return result;
            },
            sortAsc() {
                var $this = this;
                this.results.sort(function (a, b) {
                    //var a = $this.results[keyA];
                    //var b = $this.results[keyB];

                    if (a.fields.title < b.fields.title) {
                        return -1;
                    }
                    if (a.fields.title > b.fields.title) {
                        return 1;
                    }
                    return 0;
                });
            },
            sortDesc() {
                var $this = this;
                this.results.sort(function (a, b) {
                    //var a = $this.results[keyA];
                    //var b = $this.results[keyB];

                    if (a.fields.title < b.fields.title) {
                        return 1;
                    }
                    if (a.fields.title > b.fields.title) {
                        return -1;
                    }
                    return 0;
                });
            },
            sortDate(order) {
                var $this = this;
                this.results.sort(function (a, b) {
                    if (order === 'asc') {
                        return a.fields._date_ - b.fields._date_;
                    }
                    return b.fields._date_ - a.fields._date_;

                });
            },
            getDownloadType(result) {

                if (resultTemplates[result.fields.indexname]) {
                    return resultTemplates[result.fields.indexname];
                }

                return resultTemplates['default'];
            }
        },
        created: function () {
            this.updateResults();
        }
    }
</script>

<style scoped>

</style>
